
import { Stack } from '@mui/material';
import marks_results from '../../static/images/questionImages/marks_gauge.png';

export default function MinAndMaxResults() {
    return <Stack direction={"row"} spacing={2}>
        <Stack >
            Your score
            <img
                style={{ 'max-width': '200px' }}
                src={marks_results}
                alt={''}
                loading="lazy"
            />
        </Stack>
        <Stack >
            Average score
            <img
                style={{ 'max-width': '200px' }}
                src={marks_results}
                alt={''}
                loading="lazy"
            />
        </Stack>
    </Stack>
}